import React, { FC } from 'react';
import EmptyListIcon from '../icons/emptyListIcon.svg';
import styled from 'styled-components';
import { Link, PrimaryButton } from '../buttons';
import { T } from '../helpers/helpers';
import { Section } from '../section';

const TopIcon = styled.div`
    margin: 20px 0px 40px 0 !important;
`;

const EmptyListContainer = styled.div`
    display: grid;
    justify-items: center;
`;
const Header = styled.h3`
    font-size: 16px;
    margin: 0 0 20px 0;
`;

const SubHeader = styled.span`
    padding-bottom: 5px;
    white-space: pre-line;
    line-height: 20px;
    text-align: center;
`;

const LearnMoreContainer = styled.div``;

const Buttons = styled.div`
    display: flex;
    gap: 30px;
    justify-content: flex-end;
    margin-top: 40px;
`;

interface Props {
    title: string;
    subTitle: React.ReactNode;
    buttonTitle?: string;
    onButtonClick?: () => void;
    alreadyExistingButton?: React.ReactNode;
    icon?: React.ReactNode;
    hideIcon?: boolean;
    learnMoreText?: string;
    learnMoreLink?: string;
    disabledButton?: boolean;
}

export const EmptyList: FC<Props> = ({
    title,
    subTitle,
    buttonTitle,
    onButtonClick,
    alreadyExistingButton,
    learnMoreText,
    learnMoreLink,
    icon: iconLink,
    hideIcon = false,
    disabledButton = false
}) => {
    return (
        <Section>
            <EmptyListContainer>
                {!hideIcon &&
                    (iconLink ? (
                        <TopIcon>{iconLink}</TopIcon>
                    ) : (
                        <TopIcon>
                            <EmptyListIcon />
                        </TopIcon>
                    ))}
                <Header>{title}</Header>
                <SubHeader>{subTitle}</SubHeader>
                {learnMoreLink && (
                    <LearnMoreContainer>
                        <Link href={learnMoreLink} target={'_blank'}>
                            {learnMoreText ? learnMoreText : T._('Learn more', 'Admin')}
                        </Link>
                    </LearnMoreContainer>
                )}

                <Buttons>
                    {buttonTitle && onButtonClick && (
                        <PrimaryButton disabled={disabledButton} onClick={() => onButtonClick()}>
                            {buttonTitle}
                        </PrimaryButton>
                    )}
                    {alreadyExistingButton}
                </Buttons>
            </EmptyListContainer>
        </Section>
    );
};
